
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/faq",
      function () {
        return require("private-next-pages/[locale]/faq.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/faq"])
      });
    }
  